
import Messages from "./Messages"
import Input from "./Input"
import { useContext, useEffect, useMemo, useReducer, useRef, useState} from "react";
import { AuthContext } from "../AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { HbrAvatarProfile, Hbrbackarrow, HbrBulletinIcon, HbrCancel, HbrDropdownIcon, HbrDropUpIcon, HbrMenuIcon } from "../newComponents/Mycustomsvgicons";
import UseLayout from "../newComponents/useLayout";
import { get, ref } from "firebase/database";
import { realTimeDB } from "../firebase";
import { actionConsts, reducer } from "../newComponents/StateManager";
import WallpaperSelector from "../newComponents2/WallpaperSelector";
import ViewSelectedWallpaper from "../newComponents2/ViewSelectedWallpaper";
import CustomCircularProgress from "../newComponents2/CustomCircularProgressBar";
import { getWallpapers, initDB } from "../ConfigureIndexDB";
import { sanitizeText } from "../newComponents/GeneralClasses";
import WiderImageView from "../newComponents2/WiderImageView";


const Chatcontainer = () => {
    const {profile_pic} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const {user_email} = useContext(AuthContext);
    const {width} = UseLayout();
    const [dropdownmenu,setdropdown]=useState(false);
    const [chatWallpapers,setChatWallpapers]=useState([]);
    const [wallpaperFromDevice, setWallpaperFromDevice] = useState(null);
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, hideFromView: true, imageUrl:"", imageTitle:"", openImageView: false});
    const [openWallpaperSelected,setOpenWallpaperSelected]=useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const menuref = useRef(null);
    // const selectImageRef = useRef(null);
 
   
    useEffect(()=>{
      const handleCloseMenu=(e)=>{
        if(!menuref.current.contains(e.target)){
          setdropdown(false);
        }
      }
      document.addEventListener('mousedown',handleCloseMenu);
      return()=>{
        document.removeEventListener('mousedown',handleCloseMenu);
      }
    },[]);


    const fetchWallpaper = async() =>{
      dispatch({type: actionConsts.HIDE_VIEW});
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
        const wallpaperRef = await get(ref(realTimeDB,"wallpapers"));
        if (wallpaperRef.exists()) {
          const wallpaperSubdata = wallpaperRef.val();
          const getWallpapersInArray = Object.keys(wallpaperSubdata).map((key)=>({
            id: key,
            ...wallpaperSubdata[key]
          }));
          setChatWallpapers(getWallpapersInArray);
          fetchWallpaperFromLocalDB();
        }
        dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
    };

    const fetchWallpaperFromLocalDB=async()=>{
        initDB().then(() => {
            getWallpapers().then((data) =>{
              // console.log(data);
              if (data.length > 0) {
                setChatWallpapers((prev) => [...prev, ...data]);
              }
             
            }).catch((err) => {
              console.log(err);
            });
        }).catch((err)=>{
          console.log(err);
        });
    };


    const memoizedWallpapers = useMemo(()=> chatWallpapers,[chatWallpapers]);
    const fetchedWallpapers = memoizedWallpapers || [];

    const handleGetImageClicked=(imageUrl, title)=>{
      if (imageUrl) {
        dispatch({type: actionConsts.IMAGE_URL, payload: imageUrl});
        dispatch({type: actionConsts.iMAGE_TITLE, payload: title});
        setOpenWallpaperSelected(true);
      }
    };

    const handleCloseWallpaperView=(res)=>{
        if (res === true) {
          setOpenWallpaperSelected(false);
          if (wallpaperFromDevice) {
            setWallpaperFromDevice(null);
          }
        }
    };

    // const selectYourWallpaper=()=>{
    //   if (selectImageRef.current) {
    //     selectImageRef.current.click(); 
    //   }
    // };

    // const onWallpaperFromDeviceChange=(e)=>{
    //     const imageFile = e.target.files[0]
    //     // console.log(wallpaperFromDevice)
    //     if (imageFile) {
    //       const image_url = URL.createObjectURL(imageFile);
    //       const image_title = "Chat room wallpaper hbr" + ItemID();
    //       dispatch({type: actionConsts.IMAGE_URL, payload: image_url});
    //       dispatch({type: actionConsts.iMAGE_TITLE, payload: image_title});
    //       setWallpaperFromDevice(imageFile);
    //       setOpenWallpaperSelected(true);
    //     }
    // };

    const closeWallpaerFromDeviceView=()=>{
      setWallpaperFromDevice(null);
      setOpenWallpaperSelected(false);
    };

    const handleCloseImageView=()=>{
      dispatch({type: actionConsts.OPEN_IMAGE_VIEW});
    };

    const handleViewImage=()=>{
      navigate(`/profilepage?hbruserref=${sanitizeText(user_email)}&socialhandle=${userName}`, {state: {from: location.pathname}});
      // if (imageToView) {
      //     dispatch({type: actionConsts.IMAGE_URL, payload: imageToView});
      //     dispatch({type: actionConsts.OPEN_IMAGE_VIEW});
      // }
    };

    const handleClosePage=()=>{
      if (location.state && location.state.from) {
          navigate(location.state.from);
      }else{
          navigate("/");
      }
  };


    return ( 
      <div className="chat-container">

        <div className="chatInfo">
            <span>Chat Room</span>

          {width > 700 &&
            (
              <div style={{display:"flex",paddingTop:"15px",cursor:"pointer", position: "relative"}} onClick={()=>fetchWallpaper()}>
                      <h4 style={{color:"white"}}>Wallpaper</h4>
                    {state.hideFromView ? 
                    <HbrDropdownIcon width={"1.7em"} height={"1.7em"} fillColour={"#ffffff"}/>
                    :
                    <HbrDropUpIcon width={"1.7em"} height={"1.7em"} fillColour={"#ffffff"}/>
                    } 

                      {!state.hideFromView && (
                        <div className="chatwallpapersview flex-row2">
                              {state.progressIndicator && 
                            <CustomCircularProgress borderColor={"white"} borderBottomColor={"#0b6b93"} borderTopColor={"#eb268f"} top={"60%"} left={"40%"} />
                              }

                            {/* <input type="file" accept="image/*" style={{display:"none"}} ref={selectImageRef}  onChange={onWallpaperFromDeviceChange}/> */}
                              
                            {/* <div className="addyourwallpaper flex-column2">
                                <HbrAddIcon width={"4em"} height={"4em"} fillColour={"#ffffff"} handleClick={()=>selectYourWallpaper()}/>
                                <span>Select From Device</span>
                            </div> */}

                            {fetchedWallpapers && fetchedWallpapers.map(data => (
                              <WallpaperSelector 
                              key={data.id} 
                              image={data.image} 
                              title={data.title}
                              getImageClicked={handleGetImageClicked}
                              />
                            ))}

                        </div>
                      )
                    }
              </div>
            )
          }

          {width > 700 && (
              <div className="flex-row2" style={{paddingTop:"15px"}}>
                <HbrBulletinIcon width={"1.5em"} height={"1.5em"} fillColour={"teal"}/>
                <h4 style={{color:"white"}}>{userName}</h4>
            </div>
          )}

          <div className="top-icons">

              <div style={{position:"relative"}} onClick={()=>setdropdown(prev => !prev)} ref={menuref}>
                {profile_pic && profile_pic !== "" ? <img src={profile_pic} alt="User Profile"/>
                  :
                  <HbrAvatarProfile width={"2em"} height={"2em"}/>
                }

                <div style={{position: "absolute", top:"0px",left:"50%", backgroundColor:"#000000"}}>
                  <HbrMenuIcon width={"1.5em"} height={"1.5em"} fillColour={"#ffffff"}/>
                </div>

                {dropdownmenu &&
                  (
                    <div className="mcmenuoption2 flex-column1" >
                          <div className="flex-row2">
                            <HbrBulletinIcon width={"1em"} height={"1em"} fillColour={"teal"}/>
                            <h4>{userName}</h4>
                        </div>

                        <button  onClick={()=> navigate("/account/update", {state: {from: location.pathname}})}
                            style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}}>
                            Update Profile
                        </button>       

                        <button onClick={() => handleViewImage()} 
                                style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}}>
                            View
                        </button>

                        <button onClick={() => fetchWallpaper()} 
                                style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}}>
                            Wallpaper
                        </button>

                        <button onClick={() => handleClosePage()} 
                                style={{backgroundColor:"transparent",border:"none",fontWeight:"bold",cursor:"pointer"}}>
                            Exit
                        </button>

                  </div>
                  ) 
                }
              </div>
      
          </div>
        </div>

          {openWallpaperSelected && (
            <div style={{width:"100%",height:"100%",position:"fixed",background:"#1a1a1a",zIndex:"2",top:"0px",left:"0px"}}>
                <div className="closeWallpaperSelectedView">
                  <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setOpenWallpaperSelected(false)}/>
                </div>
                <ViewSelectedWallpaper image={state.imageUrl} fromDevice={false} title={state.imageTitle} handleCloseView={handleCloseWallpaperView} />
            </div>
            )
          }

          {wallpaperFromDevice && openWallpaperSelected && (
            <div style={{width:"100%",height:"100%",position:"fixed",top:"0px",left:"0px",background:"#1a1a1a",zIndex:"2"}}>
                <div className="closeWallpaperSelectedView">
                  <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>closeWallpaerFromDeviceView()}/>
                </div>
                <ViewSelectedWallpaper image={state.imageUrl} fromDevice={true} title={state.imageTitle} handleCloseView={handleCloseWallpaperView} />
            </div>
            )
          }
  
          {width <= 700 && (
                <section className={`chatwallpapersviewsmallerscreen flex-column1 ${state.hideFromView ? 'hide':'show'}`}>

                      <div className="chatwpsmallerscreenviewtop flex-spacebetween">
                        <span style={{fontWeight:"bold"}}>{`wallpaper (${fetchedWallpapers && fetchedWallpapers.length})`}</span>
                        <HbrCancel width={"1.8em"} height={"1.8em"} fillColour={"#000000"} handleClick={()=> dispatch({type: actionConsts.HIDE_VIEW})}/>
                      </div>

                      <div className="flex-row2" style={{width:"100%",height:"100%",flexWrap:"wrap",overflow:"auto",position:"relative",gap:"10px"}}>

                          {state.progressIndicator && 
                        <CustomCircularProgress borderColor={"white"} borderBottomColor={"#0b6b93"} borderTopColor={"#eb268f"} top={"60%"} left={"40%"} />
                          }

                        {/* <input type="file" accept="image/*" style={{display:"none"}} ref={selectImageRef}  onChange={onWallpaperFromDeviceChange}/>
                          
                        <div className="addyourwallpaper flex-column2">
                            <HbrAddIcon width={"4em"} height={"4em"} fillColour={"#ffffff"} handleClick={()=>selectYourWallpaper()}/>
                            <span style={{color:"white"}}>Select From Device</span>
                        </div> */}

                        {fetchedWallpapers && fetchedWallpapers.map(data => (
                          <WallpaperSelector 
                          key={data.id} 
                          image={data.image} 
                          title={data.title}
                          getImageClicked={handleGetImageClicked}
                          />
                        ))}
                      </div>
                </section>
              )
        }

        {state.openImageView && 
            <div>
                  <WiderImageView imageUrl={state.imageUrl} handleCloseView={handleCloseImageView}/>
            </div>
        }
      
        <Messages/>
        <Input/>
        </div>
     );
}
export default Chatcontainer;